
import { defineComponent, ref, Ref, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  emits: ["game-selected"],
  setup(props, { emit }) {
    const store = useStore();
    const isBeginLoading = computed(() => store.getters.getIsBeginLoading);
    const selectedGame: Ref<number | null> = ref(1); // the id of the selected game
    const games = [
      { id: 1, name: "shuffler", available: true, selected: true },
      { id: 2, name: "guess", available: false, selected: false },
      { id: 3, name: "riddles", available: true, selected: false },
    ];

    const setSelectedGame = (id: number): void => {
      const isAvailable = games.find(game => game.id === id);
      if (!isAvailable?.available) {
        store.commit("SET_SNACK", {
          type: "info",
          message: "This game is not available yet",
        });
        return;
      }
      if (isBeginLoading.value) return;

      selectedGame.value = id;
      emit("game-selected", id);
      store.commit("SET_GAME_ID", id);
    };
    return { selectedGame, games, setSelectedGame, isBeginLoading };
  },
});
